import * as React from 'react';
import { ReactChildrenGeneralType } from '../../../../models/ReactChildrenGeneralType';

type RectButtonProps = {
    title: string,
    children: ReactChildrenGeneralType,
    onClick: (e?: React.MouseEvent) => void;
    className?: string,
};


export function RectButton({ title, className, onClick, children }: RectButtonProps) {
    return <div
        title={title}
        className={`action-btn light-blue-with-border rect-button ${className}`}
        onClick={onClick}>
        {children}
    </div>;
}